import { render, staticRenderFns } from "./ChatBot.vue?vue&type=template&id=5fc5319b"
import script from "./ChatBot.vue?vue&type=script&lang=ts"
export * from "./ChatBot.vue?vue&type=script&lang=ts"
import style0 from "./ChatBot.vue?vue&type=style&index=0&id=5fc5319b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports